<template>
  <div
    class="product-card clickable"
    :data-handle="product.handle"
  >
    <!-- :min-height="345" -->
    <!-- root-margin="200px 0px 200px 0px" -->
    <ProductFlairBadge :tags="product.tags" class="absolute top-2 left-2 z-10" />
    <ProductTagIcons :tags="product.tags" />
    <a
      :href="url"
      class="product-image-wrapper flex-center shrink-0"
      data-gtm-action="product image click"
      :data-gtm-label="product.title"
    >
      <ResponsiveImage
        v-if="product.flavorForwardImage"
        :image="product.flavorForwardImage"
        :alt="product.title"
        :width="300"
        class="min-h-0 max-h-none w-[300px] max-w-none -mx-10 -mb-2"
        :class="!compact && 'lg:w-[400px]'"
      />
      <ResponsiveImage
        v-else-if="product.profileImage"
        :image="product.profileImage"
        :width="200"
        :alt="product.title"
        class="max-w-none"
      />
    </a>
    <div class="product-details flex grow items-center flex-col text-center w-full">
      <a
        :href="url"
        class="product-title grow font-medium min-h-6"
        data-gtm-action="product title click"
        :data-gtm-label="product.title"
      >
        {{ product.title }}
      </a>
      <ProductReviewsStars
        :product-id="product.id"
        :product-title="product.title"
        :count="product.ratingCount || 0"
        :rating="product.ratingAverage || 0"
      />
      <ProductNutritionLink :product="product" />
    </div>
    <BundleQuantityControl
      v-if="product.key"
      :product-key="product.key"
      :title="product.title"
      :sku="product.sku"
      class="max-w-[164px]"
    />
    <ProductNutritionLink :product="product">
      <span class="text-blue-500 text-sm font-semibold">
        {{ $t('products.nutrition_info') }}
      </span>
    </ProductNutritionLink>
    <!-- <a
      :href="url"
      class="text-blue-500 text-sm font-semibold"
      data-gtm-action="product details click"
      :data-gtm-label="product.title"
    >
      {{ $t('action.view_details') }}
    </a> -->
  </div>
</template>

<script setup lang="ts">
import { ProductTagIcons } from '@oatsovernight/storybook'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'
import ProductNutritionLink from './product-nutrition-link.vue'
import BundleQuantityControl from './bundle-quantity-control.vue'
import ProductReviewsStars from './product-reviews-stars.vue'
import { ProductFlairBadge } from '@oatsovernight/storybook'
import type { Product } from '@/types/shopify'
export interface Props {
  product: Product
  /** Narrower layout (e.g. PDP sidebar-constrained grid): skip the lg image size bump. */
  compact?: boolean
}
const props = defineProps<Props>()
const url = `/products/${props.product.handle}`
</script>
